import { themeWorkspace } from "../theme-node";

import * as Blockly from "blockly/core";

export function init() {
  return {
    kind: "category",
    name_universal: "question",
    name: "%{BKY_CATQUESTIONS}",
    colour: themeWorkspace.categoryStyles.question_category.colour,
    imageName: "/toolbox-imgs/question-solid.svg",
    id: "3",
    contents: [
      {
        kind: "block",
        type: "question_true_false",
        extraState: {
          displaymoreOptions: false,
          statement: true,
        },
        fields: {
          moreOptions: false,
        },
        inputs: {
          text: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "question",
              },
            },
          },
          solution: {
            shadow: {
              type: "logic_boolean",
              fields: {
                BOOL: "TRUE",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "question_multiple_choices",
        extraState: {
          displaymoreOptions: false,
          statement: true,
        },
        fields: {
          type: "unique",
          moreOptions: false,
        },
        inputs: {
          text: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "question",
              },
            },
          },
          solution: {
            block: {
              type: "lists_create_with",
              extraState: {
                itemCount: 1,
              },
              inputs: {
                ADD0: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
              },
            },
          },
          proposals: {
            block: {
              type: "lists_create_with",
              extraState: {
                itemCount: 2,
              },
              inputs: {
                ADD0: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                ADD1: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "question_open",
        extraState: {
          displaymoreOptions: false,
          statement: true,
        },
        fields: {
          type: "integer",
          moreOptions: false,
        },
        inputs: {
          text: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "question",
              },
            },
          },
          solution: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "question_reorder",
        extraState: {
          displaymoreOptions: false,
        },
        fields: {
          moreOptions: false,
        },
        inputs: {
          text: {
            shadow: {
              type: "text",
              fields: {
                TEXT: Blockly.Msg["QUESTION_REORDER_TEXT"],
              },
            },
          },
          solution: {
            block: {
              type: "lists_create_with",
              extraState: { itemsCount: 3 },
              inputs: {
                ADD0: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                ADD1: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                ADD2: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "question_associate",
        extraState: {
          displaymoreOptions: false,
        },
        fields: {
          moreOptions: false,
        },
        inputs: {
          text: {
            shadow: {
              type: "text",
              fields: {
                TEXT: Blockly.Msg["QUESTION_ASSOCIATE_TEXT"],
              },
            },
          },
          solution1: {
            block: {
              type: "lists_create_with",
              extraState: { itemsCount: 3 },
              inputs: {
                ADD0: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 1,
                    },
                  },
                },
                ADD1: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 2,
                    },
                  },
                },
                ADD2: {
                  shadow: {
                    type: "math_number",
                    fields: {
                      NUM: 3,
                    },
                  },
                },
              },
            },
          },
          solution2: {
            block: {
              type: "lists_create_with",
              extraState: { itemsCount: 3 },
              inputs: {
                ADD0: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "A",
                    },
                  },
                },
                ADD1: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "B",
                    },
                  },
                },
                ADD2: {
                  shadow: {
                    type: "text",
                    fields: {
                      TEXT: "C",
                    },
                  },
                },
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "question_figure",
        extraState: {
          displaymoreOptions: false,
        },
        fields: {
          board_variable: {
            name: "graphic",
            type: "",
          },
          moreOptions: false,
        },
      },
    ],
  };
}
